import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
  } from "firebase/firestore";

import { db } from "../apis/auth";
import { deviceErrorReportEventCode } from "../constants/constants";

export async function GetEventReportQuery(startDate, endDate, slcDocId = "") {
    console.log(`===== EventReportQuery : GetDailyReportQuery(startDate=${startDate}, endDate=${endDate}, devId=${slcDocId}) ========`);
    return new Promise(function(resolve, reject) {
        var deviceColRef = collection(db(), 'devices');
        // var reportQuery = query(
        //     collection(deviceColRef, slcDocId,'events'),
        //     where("evt_tm", ">=", startDate),
        //     where("evt_tm", "<=", endDate));
        // reportQuery = query(
        //     reportQuery,
        //     orderBy("evt_tm", "asc"));
        var reportQuery = query(
            collection(db(), 'devices', slcDocId, 'events'), 
            where("evt_tm", ">=", startDate),
            where("evt_tm", "<=", endDate),
            orderBy("evt_tm", "asc"));
        // debugger;
        getDocs(reportQuery).then((querySnapshot) => {
            var events = [];
            querySnapshot.forEach((doc) => {
                var data = doc.data();
                data.docId = doc.id;
                data.displayData_date = data.evt_tm?.toDate() ?? null;

                var err_st = "";
                if (data.evt_ty >= 1001 && data.evt_ty <= 5000) {
                    err_st = data.err_st == 0 ? "Clear" : "Set";
                }

                data.displayData_eventType = `${deviceErrorReportEventCode[data.evt_ty]??""} ${err_st != "" ? "("+err_st+")" : ""}`;
                data.displayData_status = JSON.stringify(data.data);
                if (deviceErrorReportEventCode[data.evt_ty] != undefined) {
                    events.push(data)
                }
            });
            resolve(events);
        }).catch((error)=>{
            console.log(`====> Error fetch : ${error}`);
            reject(error);
        }); 
    });
      
}